import React, { forwardRef, createElement } from "react"
import classNames from "classnames"

const baseClass = "wb-grid-area"

/** A GridArea should use used in conjunction with a Grid only, and defines a
 * layout component for which you can apply CSS grid layout rules to.
 * */

type StyleProps = {
  [key: string]: string
}

type GridAreaProps = {
  /** The name of the CSS grid area. */
  name: string,
  /** Allows overriding the root HTML tag. */
  as?: string,
  /** Pass in a classname with attached CSS grid layout code. Don't forget mobile responsive rules */
  className?: string,
  /** Style prop */
  style?: StyleProps,
  children?: React.ReactNode
}

const GridArea = forwardRef<HTMLElement, GridAreaProps>(({
  name,
  className,
  as = "div",
  children,
  style = {},
  ...passThroughProps
}, ref) => {

  const classes = classNames(baseClass, className)
  const props = {
    className: classes,
    style: { gridArea: name, ...style },
    ref,
    ...passThroughProps
  }

  return createElement(
    as,
    props,
    children
  )
})

GridArea.displayName = "GridArea"

export { GridArea }
export type { GridAreaProps }
